module.exports = __webpack_public_path__ + "static/media/teen-burger-mobile-399_en.d36a16ca.jpg";